import { render, staticRenderFns } from "./sidebar-admin.vue?vue&type=template&id=89028684&scoped=true&"
import script from "./sidebar-admin.vue?vue&type=script&lang=js&"
export * from "./sidebar-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89028684",
  null
  
)

export default component.exports